import React, { type ReactElement } from 'react'

import { useIntl } from 'react-intl'

import { Typography, customTV, useTheme } from '@themenu/design-system'

const typographyLinkStyle = customTV({
  base: [
    'ml-xxs inline-block',
    "before:content-[''] [&:not(:first-of-type)]:before:border-r before:mr-xxs before:opacity-50",
  ],
})

export const LegalLinkFooter = (): ReactElement => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  const linkTypeToIntlId = {
    legalNotices: 'sign_in_page.legal_links.legal_notice',
    privacy: 'sign_in_page.legal_links.privacy_policy',
    cgu: 'sign_in_page.legal_links.cgu',
    cookies: 'sign_in_page.legal_links.cookies',
  }

  return (
    <div className="text-center">
      {Object.entries(linkTypeToIntlId).map(([linkName, linkIntlId]) => {
        const linkUrlId = `${linkIntlId}.link`
        const linkUrl = formatMessage({ id: linkUrlId })
        const linkPresent = linkUrl !== linkIntlId
        const title = formatMessage({ id: `${linkIntlId}.title` })

        return (
          linkPresent && (
            <Typography
              key={linkName}
              variant="callout"
              component="a"
              href={linkUrl}
              target="_blank"
              style={{ color: theme.colors.content.placeholder }}
              className={typographyLinkStyle()}
            >
              {title}
            </Typography>
          )
        )
      })}
    </div>
  )
}
